import React from 'react';
import { motion } from 'framer-motion';

interface StorageTierBadgeProps {
  tier: 'INSTANT' | 'STANDARD' | 'ARCHIVE' | string;
  className?: string;
}

const StorageTierBadge: React.FC<StorageTierBadgeProps> = ({ tier, className = '' }) => {
  // Map tier to display properties
  const getTierConfig = (tier: string) => {
    switch (tier?.toUpperCase()) {
      case 'INSTANT':
        return {
          icon: '⚡',
          label: 'Instant',
          bgColor: 'bg-green-500',
          textColor: 'text-white'
        };
      case 'STANDARD':
        return {
          icon: '📦',
          label: 'Standard',
          bgColor: 'bg-yellow-500',
          textColor: 'text-white'
        };
      case 'ARCHIVE':
        return {
          icon: '🗄️',
          label: 'Archive',
          bgColor: 'bg-blue-500',
          textColor: 'text-white'
        };
      default:
        return {
          icon: '⚡',
          label: 'Instant',
          bgColor: 'bg-green-500',
          textColor: 'text-white'
        };
    }
  };

  const config = getTierConfig(tier);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2 }}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded ${config.bgColor} ${config.textColor} text-xs font-medium shadow-sm ${className}`}
      title={`Storage tier: ${config.label}`}
    >
      <span className="text-xs">{config.icon}</span>
      <span className="hidden sm:inline">{config.label}</span>
    </motion.div>
  );
};

export default StorageTierBadge;
